import { NodeSelectedProvider } from "../../contexts/NodeSelectedContext";
import { ConstructionProjectWrapper } from "./ConstructionProjectWrapper";

export function ConstructionProject() {
    return (
      <NodeSelectedProvider>
        <ConstructionProjectWrapper />
      </NodeSelectedProvider>
    );
}